"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.AppBaseUnavailableDatasetSchema = void 0;
const zod_1 = require("zod");
/** Public-safe batch failure. Never include host, owner or exception details. */
exports.AppBaseUnavailableDatasetSchema = zod_1.z
    .object({
    sourceKey: zod_1.z.string().min(1),
    status: zod_1.z.literal('unavailable'),
    // The table of the source is in the trash, was deleted for good or
    // waits for its manager's approval.
    reason: zod_1.z.enum([
        'access_denied',
        'not_found',
        'data_source_trashed',
        'data_source_deleted',
        'data_source_pending',
    ]),
    columns: zod_1.z.tuple([]),
    rows: zod_1.z.tuple([]),
    nextCursor: zod_1.z.null(),
})
    .strict();
